module.exports = __webpack_public_path__ + "static/media/metro.fa0792b8.jpg";